import { render } from "./ItemListHeading.vue?vue&type=template&id=00fea22d&scoped=true&ts=true"
import script from "./ItemListHeading.vue?vue&type=script&lang=ts"
export * from "./ItemListHeading.vue?vue&type=script&lang=ts"

import "./ItemListHeading.vue?vue&type=style&index=0&id=00fea22d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00fea22d"]])

export default __exports__